import React from 'react';
import locales from '../../../content.json';
import s from './nutritionSupportBlock.module.scss';
import sparkle from './img/star.png';
import flower from './img/flower.png';
import cross from './img/cross.png';
import phoneScan from './img/phone-scan.png';

export const NutritionSupportBlock = () => {
  return (
    <section className={s.block}>
      <div className={s.badge}>
        <img className={s.badgeIcon} src={sparkle} alt="" aria-hidden="true" />
        <p className={s.badgeText}>{locales[window.userLang].payment_text_290}</p>
        <img className={s.badgeIcon} src={sparkle} alt="" aria-hidden="true" />
      </div>

      <div className={s.card}>
        <h3 className={s.title}>{locales[window.userLang].payment_text_340}</h3>

        <img className={`${s.decor} ${s.decorFlower}`} src={flower} alt="" aria-hidden="true" />
        <img className={`${s.decor} ${s.decorCross}`} src={cross} alt="" aria-hidden="true" />
        <img className={s.illustration} src={phoneScan} alt="" aria-hidden="true" />
      </div>
    </section>
  );
};
